import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useCallback } from 'react';
import { View, Text, TextInput, Image } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { SccPressable } from '@/components/SccPressable';
import CharacterWheelyBuggyIcon from '@/assets/icon/character_wheely_buggy.svg';
import { useEditMode } from '../context/EditModeContext';
import { useResponsive } from '../context/ResponsiveContext';
// CTA Footer 이미지
const ctaFooterImagePc = require('@/assets/icon/cta_bbucle_road_footer_pc.png');
const ctaFooterImageMobile = require('@/assets/icon/cta_bbucle_road_footer_mobile.png');
export default function CTAFooterSection({ ctaFooterSection, hideCharacter, }) {
    var _a;
    const editContext = useEditMode();
    const isEditMode = (_a = editContext === null || editContext === void 0 ? void 0 : editContext.isEditMode) !== null && _a !== void 0 ? _a : false;
    const { isDesktop } = useResponsive();
    const { buttonUrl } = ctaFooterSection;
    const updateCTAFooterSection = useCallback((updates) => {
        if (!editContext)
            return;
        editContext.updateData((prev) => (Object.assign(Object.assign({}, prev), { ctaFooterSection: prev.ctaFooterSection
                ? Object.assign(Object.assign({}, prev.ctaFooterSection), updates) : null })));
    }, [editContext]);
    const handleButtonUrlChange = useCallback((text) => {
        updateCTAFooterSection({ buttonUrl: text });
    }, [updateCTAFooterSection]);
    const handleCTAPress = useCallback(() => {
        window.location.href = '/bbucle-road';
    }, []);
    return (_jsxs(Container, { isDesktop: isDesktop, children: [_jsxs(OuterWrapper, { children: [!hideCharacter &&
                        _jsx(CharacterWrapper, { isDesktop: isDesktop, children: _jsx(CharacterWheelyBuggyIcon, { width: isDesktop ? 121 : 52, height: isDesktop ? 71 : 31, viewBox: "0 0 121 71" }) }), _jsxs(ContentWrapper, { isDesktop: isDesktop, children: [_jsxs(TextAndButtonWrapper, { isDesktop: isDesktop, children: [_jsxs(TitleWrapper, { isDesktop: isDesktop, children: [_jsx(TitleLine, { isDesktop: isDesktop, children: "\uB2E4\uB978 \uC7A5\uC18C\uC758 \uC811\uADFC\uC131 \uC815\uBCF4\uB3C4" }), _jsx(TitleLine, { isDesktop: isDesktop, children: "\uD655\uC778\uD558\uACE0 \uC2F6\uB2E4\uBA74?" })] }), _jsx(SccPressable, { onPress: handleCTAPress, elementName: "bbucle-road-cta-button", trackView: true, logParams: { buttonUrl, isDesktop }, disableLogging: isEditMode, children: _jsx(CTAButtonContent, { isDesktop: isDesktop, children: _jsx(CTAButtonText, { isDesktop: isDesktop, children: "\uC7A5\uC18C \uBAA9\uB85D \uD655\uC778\uD558\uAE30" }) }) })] }), _jsx(FooterImageWrapper, { isDesktop: isDesktop, children: _jsx(FooterImage, { source: isDesktop ? ctaFooterImagePc : ctaFooterImageMobile, resizeMode: "contain", isDesktop: isDesktop }) })] })] }), isEditMode && (_jsx(EditFieldsContainer, { isDesktop: isDesktop, children: _jsxs(EditFieldRow, { children: [_jsx(EditLabel, { children: "\uBC84\uD2BC URL:" }), _jsx(EditInput, { value: buttonUrl, onChangeText: handleButtonUrlChange, placeholder: "https://...", placeholderTextColor: "#999" })] }) }))] }));
}
const Container = styled(View) `
  width: 100%;
  background-color: #0e64d3;
  padding-top: ${({ isDesktop }) => (isDesktop ? '60px' : '40px')};
  padding-bottom: ${({ isDesktop }) => (isDesktop ? '60px' : '30px')};
`;
const OuterWrapper = styled(View) `
  max-width: 1020px;
  width: 100%;
  margin-horizontal: auto;
  position: relative;
`;
const CharacterWrapper = styled(View) `
  position: absolute;
  top: ${({ isDesktop }) => (isDesktop ? '-130px' : '-70px')};
  left: ${({ isDesktop }) => (isDesktop ? '0px' : '18px')};
`;
const ContentWrapper = styled(View) `
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${({ isDesktop }) => (isDesktop ? '40px' : '0px')};
  padding: ${({ isDesktop }) => (isDesktop ? '0px' : '0px 14px 0px 16px')};
`;
const TextAndButtonWrapper = styled(View) `
  flex: ${({ isDesktop }) => (isDesktop ? 'none' : '1')};
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ isDesktop }) => (isDesktop ? '32px' : '12px')};
`;
const TitleWrapper = styled(View) `
  align-items: flex-start;
`;
const TitleLine = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '28px' : '20px')};
  font-weight: 700;
  color: #ffffff;
  line-height: ${({ isDesktop }) => (isDesktop ? '38px' : '28px')};
  letter-spacing: -0.36px;
`;
const CTAButtonContent = styled(View) `
  background-color: #ffffff;
  padding-horizontal: ${({ isDesktop }) => (isDesktop ? '35px' : '18px')};
  padding-vertical: ${({ isDesktop }) => (isDesktop ? '12px' : '7px')};
  border-radius: 100px;
  border-width: 1px;
  border-color: #0c76f7;
  align-items: center;
  justify-content: center;
`;
const CTAButtonText = styled(Text) `
  font-family: Pretendard;
  font-size: ${({ isDesktop }) => (isDesktop ? '18px' : '14px')};
  font-weight: 500;
  color: #232328;
  line-height: ${({ isDesktop }) => (isDesktop ? '26px' : '20px')};
`;
const FooterImageWrapper = styled(View) `
  margin-right: ${({ isDesktop }) => (isDesktop ? '34px' : '0px')};
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
`;
const FooterImage = styled(Image) `
  width: ${({ isDesktop }) => (isDesktop ? '365.73px' : '138px')};
  height: ${({ isDesktop }) => (isDesktop ? '150px' : '85px')};
`;
const EditFieldsContainer = styled(View) `
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 16px;
  gap: 12px;
  max-width: 500px;
  align-self: center;
  margin-top: 24px;
`;
const EditFieldRow = styled(View) `
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
const EditLabel = styled(Text) `
  font-size: 14px;
  color: #ffffff;
  min-width: 80px;
`;
const EditInput = styled(TextInput) `
  flex: 1;
  font-size: 14px;
  color: ${color.black};
  background-color: ${color.white};
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 250px;
`;
